import Vue from "vue";
import axios from "axios";
import store from "../../../../../../stores/application/index.js.erb";

const prtfAchTypePath = `/portfolio/api/admin/prtf_achievement_types`;

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const PrtfAchievementKindApiAdminService = {

    index(typeId) {
        get_token();
        try {
            return axios.get(`${prtfAchTypePath}/${typeId}/prtf_achievement_kinds`);
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, тип деятельности не был подгружен!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    show(typeId, kindId) {
        get_token();
        try {
            return axios.get(`${prtfAchTypePath}/${typeId}/prtf_achievement_kinds/${kindId}`);
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, тип деятельности не был подгружен!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    create(idType,payload) {
        get_token();
        try {
            return axios.post(`${prtfAchTypePath}/${idType}/prtf_achievement_kinds`, {prtf_achievement_kind: payload});
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, тип деятельности не был подгружен!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    update(typeId, kindId, payload) {
        get_token();
        try {
            return axios.patch(`${prtfAchTypePath}/${typeId}/prtf_achievement_kinds/${kindId}`,
                {prtf_achievement_kind: payload});
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, тип деятельности не был подгружен!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    delete(typeId,kindId) {
        get_token();
        try {
            return axios.delete(`${prtfAchTypePath}/${typeId}/prtf_achievement_kinds/${kindId}`);
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, тип деятельности не был подгружен!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    async toggleHiddenAchievementKind(idType, idKind) {
        get_token();
        try {
            return await axios.patch(`${prtfAchTypePath}/${idType}/prtf_achievement_kinds/${idKind}/toggle_hidden_achievement_kind`);
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, попробуйте позже!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

}

export default PrtfAchievementKindApiAdminService;